import { httpRequest } from './httpClient'
import { buildPackWithLocalImages, resizeAnalysisImage } from '@/utils/exportPerformance'

export const listCategories = () =>
  httpRequest('/api/export/categories', { method: 'GET' })

export const analyzeAttributes = async (category, images, title, fabric) => {
  const started = performance.now()
  const prepared = await Promise.all(images.map(resizeAnalysisImage))
  const preparedAt = performance.now()
  try {
    return await httpRequest('/api/export/analyze-attributes', {
    method: 'POST',
    body: { category, images: prepared, title, fabric }
  })
  } finally {
    console.info('[export analyze]', { images: prepared.length, prepareMs: Math.round(preparedAt - started), requestMs: Math.round(performance.now() - preparedAt) })
  }
}

const requestPack = (sku, productJson, images) =>
  httpRequest('/api/export/build-pack', {
    method: 'POST',
    body: { sku, productJson, images },
    responseType: 'blob'
  })

export const buildPack = async (sku, productJson, images) => {
  const started = performance.now()
  try {
    return await buildPackWithLocalImages(sku, productJson, images, requestPack)
  } finally {
    console.info('[export pack]', { images: images.length, localImages: images.filter(i => i.url?.startsWith('data:image/')).length, totalMs: Math.round(performance.now() - started) })
  }
}
